import { Injectable } from "@angular/core";
import {
  BulkOrderLifeCycleEventImpl,
  BulkOrderRequestImpl,
  FixingOrderRequestImpl,
  StandardReport,
  StandardReportImpl,
} from "shared/cubiq-model-multi-asset";
import { CubiqWorker } from "shared/cubiq-services/worker/CubiqWorker";

@Injectable()
export class AllocationBulkingService {
  constructor(private worker: CubiqWorker) {}

  /**
   * Sends all bulking requests to the server for bulking - it is assumed that all validation has already been done
   * on the order requests
   *
   * @param orderRequests
   * @returns
   */
  public bulkOrders(orderRequests: FixingOrderRequestImpl[]): Promise<StandardReport> {
    return this.sendBMBulkingRequests(orderRequests);
  }

  /**
   * Send requests to the server
   * @param requestOrders
   * @returns
   */
  public sendBMBulkingRequests(requestOrders: FixingOrderRequestImpl[]): Promise<StandardReport> {
    let bulkRequest: BulkOrderRequestImpl = new BulkOrderRequestImpl();
    bulkRequest.orderRequests = requestOrders;

    bulkRequest.isBulkingReportRequest = true;

    return new Promise<StandardReport>((res, rej) => {
      this.worker.postServiceRequest(bulkRequest).then(
        (value: BulkOrderLifeCycleEventImpl) => {
          if (value instanceof StandardReportImpl) {
            res(value);
          } else {
            console.log(`BulkOrderRequestImpl failed %O`, value);
            rej(value);
          }
        },
        (err) => {
          console.log(err);
          rej(err);
        },
      );
    });
  }
}
